import lmsAPI from "./lmsAPI";

class MapSettingsService {
  async index() {
    const res = await lmsAPI.get("/map_settings");
    return res.data;
  }

  async update(settingsParams) {
    const res = await lmsAPI.put(`/map_settings`, {
      settings: settingsParams,
    });
    return res.data;
  }
}

export default new MapSettingsService();
